import { render, staticRenderFns } from "./EditDpaFileComponent.vue?vue&type=template&id=80672894&"
import script from "./EditDpaFileComponent.vue?vue&type=script&lang=js&"
export * from "./EditDpaFileComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports